// Site Configuration - Change these values to customize your site
export const siteConfig = {
  // Company Information
  companyName: "All coder performance.com \n",
  domain: "allcoder-performance.com",
  
  // Colors (change to match your brand)
  colors: {
    primary: "#e74c3c",      // Main red color
    secondary: "#2c3e50",    // Dark blue/gray
    accent: "#f39c12",       // Orange accent
    background: "#ffffff",   // White background
    text: "#333333",         // Dark text
    lightGray: "#f8f9fa"     // Light gray sections
  },
  
  // Logo (update with your logo path)
  logo: {
    text: "All coder performance",
    subtitle: "All coder performance Services"

  },
  
  // Contact Information
  contact: {
    phone: "+49 179 1509249",
    email: "info@allcoder-performance.com",
    locations: ["Flämingstraße 3–4", "15738", "Zeuthen",]
  },
  
  // Hero Section
  hero: {
    title: "Spezialist für Fahrzeugoptimierung",
    discount: "Bis zu 30% Rabatt",
    features: [
      "Mehr Leistung",
      "Weniger Verbrauch",
      "Besseres Ansprechverhalten",
      "2 Jahre Garantie"
    ]
  },
  
  // Performance Stats
  stats: {
    diesel: { value: 35, label: "Turbo-Diesel" },
    petrol: { value: 45, label: "Benzin mit Turbolader" },
    naturally: { value: 15, label: "Ohne Turbolader" }
  },
  
  // Services
  services: [
    {
      title: "Chip tuning",
      description: "Professionelle Chip tuning-Optimierung durch unsere erfahrenen Experten."
    },
    {
      title: "Programmierung",
      description: "Professionelle Programmierung-Optimierung mit modernster Software."
    },
    {
      title: "Leistungszuwachs",
      description: "Maximale Leistungssteigerung für Ihr Fahrzeug."
    },
    {
      title: "Verbrauch",
      description: "Optimierung für geringeren Kraftstoffverbrauch."
    }
  ],
  
  // Car Brands
  brands: [
    "Audi", "BMW", "Mercedes", "VW", "Porsche", "Ford", 
    "Opel", "Seat", "Skoda", "Toyota", "Nissan", "Honda"
  ]
};
